import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";

export async function updateStatusKoperasi(data) {
  try {
    const response = await baseAxios.post("webUser/approveUser", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getAllUser(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webUser/getAllUser?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusKoperasi=${data.statusKoperasi}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    console.log(response.data, "halo");
    dispatch({
      type: "SET_GETALL_USER",
      data: response.data,
    });

    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function getNewUser(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webUser/getNewUser?page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    dispatch({
      type: "SET_GET_NEW_USER",
      data: response.data,
    });

    return response;
  } catch (err) {
    return err.response;
  }
}

export function downloadDataExcel(data) {
  baseAxios
    .get("/webPurchaseOrder/downloadDataExcel", {
      headers: { token: localStorage.getItem("token") },
      responseType: "blob",
    })
    .then(async (respon) => {
      const url = window.URL.createObjectURL(new Blob([respon.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Data Purchase Order.xlsx`);
      document.body.appendChild(link);
      link.click();
      Swal.close();
    })
    .catch((err) => {});
}

export async function ubahRole(data) {
  try {
    const response = await baseAxios.post("webUser/ubahRole", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getAllProfile(dispatch, data, history) {
  try {
    const response = await baseAxios.get("webUser/profile", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_PROFILE_USER", data: response.data });

    return response;
  } catch (err) {
    return err.response;
  }
}

export async function updateFotoProfile(formData) {
  try {
    const response = await baseAxios.post("webUser/updateFotoProfile", formData, {
      headers: {
        token: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getFormRegister(data) {
  try {
    const response = await baseAxios.post("webPdf/formRegister", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching PDF:", err);
    throw err;
  }
}

export async function getBulkFormRegister(data) {
  try {
    const response = await baseAxios.post("webPdf/formRegister/bulk", data, {
      headers: { token: localStorage.getItem("token") },
      responseType: "blob",
    });
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function exportUser(data) {
  try {
    const response = await baseAxios.post("webUser/exportNewUser", data, {
      headers: { token: localStorage.getItem("token") },
      responseType: "blob",
    });

    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function exportUserGajiPokok() {
  try {
    const response = await baseAxios.get("webUser/exportGajiPokok", {
      headers: { token: localStorage.getItem("token") },
      responseType: "blob",
    });

    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getPengajuanKeluar(statusPengajuan = "", search = "") {
  try {
    const params = new URLSearchParams();
    if (statusPengajuan) params.set("statusPengajuan", statusPengajuan);
    if (search) params.set("search", search);
    const response = await baseAxios.get(
      `webUser/getPengajuanKeluarKoperasi${params.toString() ? `?${params.toString()}` : ""}`,
      { headers: { token: localStorage.getItem("token") } },
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
}

export async function exportPengajuanKeluar({
  tglAwal = "",
  tglAkhir = "",
  statusPengajuan = "",
  search = "",
} = {}) {
  try {
    const params = new URLSearchParams();
    if (tglAwal) params.set("tglAwal", tglAwal);
    if (tglAkhir) params.set("tglAkhir", tglAkhir);
    if (statusPengajuan) params.set("statusPengajuan", statusPengajuan);
    if (search) params.set("search", search);
    const response = await baseAxios.get(
      `webUser/exportPengajuanKeluarKoperasi${params.toString() ? `?${params.toString()}` : ""}`,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function approvalKeluar(data) {
  try {
    const response = await baseAxios.post("webUser/approvalKeluarKoperasi", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (error) {
    return error.response;
  }
}

export async function resetUserLama(data) {
  try {
    const response = await baseAxios.post("webUser/resetUserLama", data, {
      headers: { token: localStorage.getItem("token") },
    });

    return response;
  } catch (error) {
    return error.response;
  }
}

export async function gantiPassword(data) {
  try {
    const response = await baseAxios.post("webUser/ubahpasswordweb", data, {
      headers: { token: localStorage.getItem("token") },
    });

    return response.data;
  } catch (error) {
    return error.response;
  }
}

export async function resetPasswordDefault(data) {
  try {
    const response = await baseAxios.post(
      "webUser/resetPasswordDefault",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );

    return response;
  } catch (error) {
    return error.response;
  }
}

export async function resetGantiDevice(data) {
  try {
    const response = await baseAxios.post("webUser/resetGantiDevice", data, {
      headers: { token: localStorage.getItem("token") },
    });

    return response;
  } catch (error) {
    return error.response;
  }
}

export async function importGajiPokok(data) {
  try {
    const response = await baseAxios.post("webUser/importGajiPokok", data, {
      headers: { token: localStorage.getItem("token") },
    });

    return response;
  } catch (error) {
    return error.response;
  }
}
